/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{position:absolute;top:0;right:0;bottom:0;left:0;display:flex}dx-box[_ngcontent-%COMP%]{flex:auto}.link[_ngcontent-%COMP%]{color:#00f}"];
export { styles as styles };
